export const VALUES = {
  bodyLoadingSkeletonCount: 6,
  localStorageKeys: {issueNewBody: (prefix: string, issueId: string) => `${prefix}-i${issueId}.view-issue-body-edit`},
}
